import { PLAN_NAME } from 'constants/index';

export const returnIsTimesheetsSubscribed = subscription => {
  if (
    subscription?.Plan?.Name === PLAN_NAME.PREMIUM ||
    subscription?.Plan?.Name === PLAN_NAME.UNLIMITED
  ) {
    return true;
  }
};
